import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { Panel, Button, Col, Row, DropdownButton, MenuItem, HelpBlock } from 'react-bootstrap';
import { FormActions, DateTimeInput, Select, Radio } from '../../../common/components/formControls';
import CentersDropdownList from '../../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import TermsDropdownList from '../../terms/DropdownList';
import utils from '../../../common/services/utils';
import validators from '../../../common/services/validators';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';

export const PeriodTypes = {
	TERM: 'term',
	MONTH: 'month',
	DATE: 'date'
};

const getPeriodTypeOptions = t => {
	return [
		{ value: PeriodTypes.TERM, label: t('RoyaltyReport_Term') },
		{ value: PeriodTypes.MONTH, label: t('RoyaltyReport_Month') },
		{ value: PeriodTypes.DATE, label: t('RoyaltyReport_DateRange') }
	];
};

const Filter = ({ handleSubmit, reset, loading, t, months, years, onTermSelected,
	onSubmit, periodType, bookingTypes }) => {
	const menuItemInnerStyle = { display: 'block', padding: '10px 20px' };
	const handleReset = () => {
		reset();
		setTimeout(() => handleSubmit());
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit(values => onSubmit({ ...values }))}>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' filter={center => !center.isKindergarten} label={t('RoyaltyReport_Center')} />
						</Col>
						<Col sm={6}>
							<Field name='periodType' component={Radio} entries={getPeriodTypeOptions(t)} inline label={t('RoyaltyReport_PeriodType')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='bookingType' label={t('RoyaltyReport_BookingType')} data={bookingTypes} />
						</Col>
						<Col sm={6}>
							{periodType === PeriodTypes.TERM && <TermsDropdownList render='field' name='termId' defaultSelection='active' hideEmptyOption
								label={t('RoyaltyReport_Term')} onChange={onTermSelected} />}
							{periodType === PeriodTypes.MONTH && <Row>
								<Col sm={6}>
									<Select name='year' data={years} hideEmptyOption label={t('MonthlyPaymentReport_Year')} />
								</Col>
								<Col sm={6}>
									<Select name='month' data={months} hideEmptyOption label={t('MonthlyPaymentReport_Month')} />
								</Col>
							</Row>}
							{periodType === PeriodTypes.DATE && <Row>
								<Col sm={6}>
									<Field name='startDate' component={DateTimeInput} showTime={false} required defaultCurrentDate={utils.defaultDatePeriodFrom()} placeholder={t('Common_From')} label={t('RoyaltyReport_DateRange')} validate={validators.required} />
								</Col>
								<Col sm={6}>
									<Field name='endDate' component={DateTimeInput} showTime={false} required defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' validate={validators.required} />
								</Col>
							</Row>}
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<DropdownButton title={<span>{t('Common_Export')} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret disabled={loading} bsStyle='warning'>
							<MenuItem key='Excel' eventKey='Excel' onSelect={handleSubmit(values => onSubmit({ ...values, exportFormat: 'Excel' }))}>
								<span style={menuItemInnerStyle} >{t('Common_ExportToExcel')}</span>
							</MenuItem>
							<MenuItem key='Xero' eventKey='Xero' onSelect={handleSubmit(values => onSubmit({ ...values, exportFormat: 'Xero' }))} >
								<span style={menuItemInnerStyle} >{t('Common_ExportToXeroCSV')}</span>
							</MenuItem>
							<MenuItem key='Payments' eventKey='Payments' onSelect={handleSubmit(values => onSubmit({ ...values, exportFormat: 'Payments' }))} >
								<span style={menuItemInnerStyle} >{t('Royalty_ExportPayments')}</span>
							</MenuItem>
						</DropdownButton>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'royaltyReportFilter' })(withTranslation()(Filter));

export const selector = formValueSelector('royaltyReportFilter');